import { render } from "./AuctionParticipantsListWidget.vue?vue&type=template&id=c68dbce4&scoped=true&ts=true"
import script from "./AuctionParticipantsListWidget.vue?vue&type=script&lang=ts"
export * from "./AuctionParticipantsListWidget.vue?vue&type=script&lang=ts"

import "./AuctionParticipantsListWidget.vue?vue&type=style&index=0&id=c68dbce4&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c68dbce4"]])

export default __exports__